module.exports = __webpack_public_path__ + "static/media/pizza-milano-1.eafcab8e.jpg";